<template  >
  <b-modal
    id="holidaysSummary-modal"
    ref="modal"
    :title="titleYear"
    hide-footer
    size="lg"
    @shown="onShow"
    @hidden="hide"
  >
    <b-form-select
      v-model="selectedYear"
      :options="selectYear"
      @change="getHolidaysSummary()"
    ></b-form-select>
    <b-table
      class="table table-list table-mobile"
      ref="holidays_table"
      :fields="fields"
      :items="summary"
      :busy.sync="isBusy"
      stacked="lg"
    >
      <template v-slot:cell(total)="data">{{
        data.item.holiday + data.item.sickness + data.item.other
      }}</template>
      <template v-slot:table-busy>
        <TableSpiner />
      </template>
      <template v-slot:thead-top>
        <b-tr>
          <b-th colspan="1" variant="secondary"></b-th>
          <b-th colspan="4" class="text-center" variant="primary"
            >Wykorzystane dni</b-th
          >
        </b-tr>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import HolidaysService from "@/services/holidays.service";
import TableSpiner from "../TableSpiner";
import dayjs from "dayjs";

//TODO: dodać selet box na lata
//      dodać funkcje dla tabeli isBusy
//      poprawić działanie ładowania paska this.$Progress.start();

export default {
  name: "ModalHolidaysSummary",
  components: {
    TableSpiner,
  },
  props: {
    year: { type: Number },
    event: {
      type: Array,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "name", label: "Imię i Nazwisko" },
        { key: "holiday", label: "Urlop", class: "text-right" },
        { key: "sickness", label: "Chorobowe", class: "text-right" },
        { key: "other", label: "Inne", class: "text-right" },
        { key: "total", label: "Łącznie", class: "text-right" },
      ],
      selectYear: [],
      selectedYear: "",
      summary: [],
    };
  },
  mounted() {
    // this.currentYear = dayjs(),
    this.minYear = parseInt("2020");
    this.currentYear = parseInt(dayjs().format("YYYY"));
    this.selectYear.push({
      text: this.currentYear + 1,
      value: this.currentYear + 1,
    });
    for (var i = this.currentYear; i >= this.minYear; i--) {
      this.selectYear.push({ text: this.currentYear, value: this.currentYear });
      this.currentYear = this.currentYear - 1;
    }
  },
  computed: {
    titleYear() {
      return "Podsumowanie urlopów z " + this.year;
    },
  },
  methods: {
    getHolidaysSummary() {
      this.summary = [];
      this.isBusy = true;
      HolidaysService.getByYear(this.selectedYear)
        .then((results) => {
          this.isBusy = false;
          this.calculateHistory(results);
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    calculateHistory(results) {
      this.summary = [];
      for (var i = 0, n = results.length; i < n; i++) {
        var item = results[i];
        if (!this.summary[item.title]) {
          this.summary[item.title] = {
            name: item.title,
            holiday: 0,
            sickness: 0,
            other: 0,
            total: 0,
          };
        }
        var numberOfDays = this.calculateDateRange(item.start, item.end);
        var holidayType = item.type;
        if (typeof this.summary[item.title][holidayType] === "undefined") {
          this.summary[item.title][holidayType] = 0;
        }
        this.summary[item.title][holidayType] += numberOfDays;
        this.summary[item.title].total += numberOfDays;
      }
      this.summary = Object.values(this.summary);
    },
    calculateDateRange(from, to) {
      return dayjs(to).diff(dayjs(from), "days") + 1;
    },
    onShow() {
      this.selectedYear = this.year;
      this.getHolidaysSummary();
    },
    hide() {
      this.events = null;
    },
  },
};
</script>
